import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { TranslateModule } from '@ngx-translate/core';
import { ScrapReason } from '../../../api/backend/types/scrap-reason';
import { FormScrapReasonsService } from './form-scrap-reasons.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-form-scrap-reasons',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    TranslateModule,
    ReactiveFormsModule,
  ],
  templateUrl: './form-scrap-reasons.component.html',
  styleUrls: ['./form-scrap-reasons.component.sass'],
})
export class FormScrapReasonsComponent implements OnInit {
  @Input() withCauses = false;

  @Input() set reasons(value: ScrapReason[]) {
    this.service.scrapReasons = value;
  }

  /**
   * @description
   * Este valor define el maximo de scrap que se puede tener en la suma de todos
   * los scraps que se agregan.
   * @param value - El valor maximo de scraps que se pueden agregar.
   */
  @Input() set quantity(value: number) {
    this.service.quantity = value;
  }

  reasonsFiltered$ = this.service.reasonsFiltered$;
  formArray$ = this.service.formArray$;

  get searchReasonControl(): FormControl {
    return this.service.searchReasonControl;
  }

  validateAdd$ = this.service.addReasonValidation$.pipe(map((value) => !value));
  notSelectableReasonsIds: number[] = [];

  get maxQuantity(): number {
    return this.service.quantity;
  }

  constructor(private service: FormScrapReasonsService) {}

  ngOnInit(): void {
    this.service.reasonsAlreadySelected$.subscribe((data) => {
      this.notSelectableReasonsIds = data;
    });
  }

  addNewReason(): void {
    this.service.addNewReason();
  }

  removeNewReason(index: number): void {
    this.service.removeReason(index);
  }
}
